import { LoaderFunctionArgs } from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import { loadListingBrowse } from "~/pages/UnitPages/listingBrowse/loadListingBrowse";
import type { ListingBrowsePageLoaderResult } from "~/types/listing";

export const UnitListPageLoader = async ({ request }: LoaderFunctionArgs) => {
  return loadListingBrowse(request);
};

export type UnitListPageLoaderType = ListingBrowsePageLoaderResult;

export const UnitListPageErrorBoundary = () => {
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
